import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import isEmail from "validator/lib/isEmail";
import { useTranslation } from "react-i18next";

import { CustomSelectComponent } from "../../common/CustomSelectComponent";
import { IRISService } from "../../service/IRISService";
import { SignerService } from "../../service/SignerService";
import { LoadingContent } from "../../common/LoadingContent";
import { CognitoService } from "../../service/CognitoService";
import { trackBusinessEvt } from "../../common/CustomEvents";
import { makeStyles } from "@material-ui/core/styles";
import TextInput from "react-autocomplete-input";
import "react-autocomplete-input/dist/bundle.css";
import Chip from "@material-ui/core/Chip";
import { Icon } from "@iconify/react";
import get from "lodash/get";

import { getCognitoUser, sha256, getIIRISCookie } from "../../common/IdentityUtils";

import classes from "./OnePageSocial.module.css";

var fieldInfo = {};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "contents",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

export const OnePageSocial = (props) => {
  const { identityConfig, user, setPosition, idToken } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isLocalUser, setIsLocalUser] = useState(false);
  const { t } = useTranslation();
  const emailInputRef = useRef();
  const [countryData, setCountryData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [countryType, setCountryType] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [error, setError] = useState("");
  const [socialType, setSocialType] = useState("");
  const [userAttributes, setUserAttributes] = useState({});
  const givenNameInputRef = useRef();
  const familyNameInputRef = useRef();
  const [userObj, setUserObj] = useState(user != null ? user : null);
  const privacy_policy_text = t("privacy_policy_text");
  const [FP_text, setFPConsentText] = useState("");
  const [fp_consent, setFPConsent] = useState(null);
  const [isTypeAConsentSelected, setTypeAConsentSelected] = useState(false);
  const [isTypeDConsentSelected, setTypeDConsentSelected] = useState(false);
  const { pages, division, brand, language, configureRoles } = identityConfig;
  const classesMat = useStyles();
  const [questionData, setQuestionData] = useState({});
  const [filteredQuestionData, setFilteredQuestionData] = useState({});
  const [profilePic, setProfilePic] = useState("");
  const [fullName, setFullName] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [checkedListItems, setCheckedListItems] = useState([]);

  const authToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("IRIS_AUTH="))
    .split("=")[1];
  const userDomain = userObj.email.split("@")[1];

  useEffect(() => {
    const userDomain = userObj.email.split("@")[1];
    const fetchCompany = async (domain) => {
      try {
        const companyData = await axios.get(
          `${identityConfig.apiBaseURL}/v4/enrichment/company/domain/${domain}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: authToken,
            },
          }
        );
        setCompanyData(companyData.data);
      } catch (e) {
        setCompanyData({});
      }
    };
    if (
      !identityConfig.show_progressive_profile &&
      has_company_question(identityConfig.pages)
    ) {
      fetchCompany(userDomain);
    }
  }, [authToken, identityConfig.apiBaseURL, userObj]);

  function has_company_question(pages) {
    pages.map((page, index) => {
      page.questions.map(async (question, i) => {
        let id = question.profile_id ? question.profile_id : question.id;
        if (id === "company") {
          return true;
        }
      });
    });
    return false;
  }
  const updateCognitoAttribute = async (
    businessEmail,
    isLinkedInLogin,
    email
  ) => {
    // UPDATE USER WITH BUSINESS EMAIL
    try {
      await CognitoService.updateUserAttributes({
        Name: "custom:business_email",
        Value: businessEmail,
      });
    } catch (e) {
      console.log(e);
    }
    try {
      await CognitoService.updateTokens(
        identityConfig.clientId,
        isLinkedInLogin,
        email
      ).then((token) => {
        authToken = token.access_token;
        //idToken = token.id_token;
      });
    } catch (e) {
      console.log(e);
    }
  };

  const validateField = (field) => {
    if (field.value === "") {
      field.classList.add(classes["error-border"]);
      setErrors([...errors, field.id]);
    } else {
      field.classList.remove(classes["error-border"]);
      const index = errors.findIndex((error) => error === field.id);
      if (index !== -1) {
        let newErrors = [...errors];
        newErrors.splice(index, 1);
        setErrors(newErrors);
      }
    }
    setError("");
  };

  function hasError(key) {
    return errors.indexOf(key) !== -1;
  }

  const handleConsent = async (token, userObj) => {
    try {
      const consentPayload = {
        iiris_id: userObj.id,
        product_id: identityConfig.id,
        product_type: identityConfig.siteType,
        product_sub_type: identityConfig.siteSubType,
        version: "2.x",
        date: new Date(),
        country: userObj.country,
        country_group: userObj.countryType ? userObj.countryType : "",
        consent: [
          {
            type: "PP",
            sub_type: "",
            text: privacy_policy_text,
            link: "https://www.informa.com/privacy-policy/",
            flag: true,
          },
        ],
      };
      if (fp_consent !== null) {
        consentPayload.consent.push({
          type: "1P",
          sub_type: "non-purchase",
          text: FP_text,
          link: "",
          flag: fp_consent,
        });
      } else if (
        fp_consent == null &&
        (countryType === "B" || countryType === "C")
      ) {
        consentPayload.consent.push({
          type: "1P",
          sub_type: "non-purchase",
          text: t("tick_here_text"),
          link: "",
          flag: true,
        });
      }

      IRISService.makePostRequest(
        identityConfig.apiBaseURL + "/v3/audience/consent",
        consentPayload,
        token
      );
    } catch (e) {
      console.log(e);
    }
  };

  const validateForm = () => {
    const enteredEmail = emailInputRef.current.value;
    let socialType = "";
    if (userObj.identities) {
      const identities = JSON.parse(userObj.identities);
      socialType = identities[0].providerName.toLowerCase();
    }
    let isValid = true;
    let errs = [];
    if (enteredEmail === "") {
      isValid = false;
      errs.push("emailInputRef");
    }
    if (socialType === "signinwithapple") {
      const firstName = givenNameInputRef.current.value;
      const lastName = familyNameInputRef.current.value;
      if (firstName === "") {
        isValid = false;
        errs.push("givenNameInputRef");
      }
      if (lastName === "") {
        isValid = false;
        errs.push("familyNameInputRef");
      }
    }
    //email validation
    var validEmail = isEmail(enteredEmail);
    if (!validEmail) {
      isValid = false;
      errs.push("emailInputRef");
    }
    if (!userObj.family_name && familyNameInputRef.current.value === "") {
      isValid = false;
      errs.push("familyNameInputRef");
    }
    if (selectedCountry === "") {
      isValid = false;
      errs.push("country");
    }
    if (selectedState === "" && stateData.length > 0) {
      isValid = false;
      errs.push("state");
    }
    switch (countryType) {
      case "A":
        if (!isTypeAConsentSelected) {
          isValid = false;
          errs.push("Aterms");
        }
        break;
      case "D":
        if (!isTypeDConsentSelected) {
          isValid = false;
          errs.push("Cterms");
        }
        break;
      default:
        break;
    }

    questionSelection.map((page, index) =>
      page[`page${index + 1}`].map((question) => {
        let profile_id = question.profile_id
          ? question.profile_id
          : question.id;
        let question_type = question.type ? question.type : "";
        const selectedQuestionId = profile_id;
        const selectedQuestionVal = question[profile_id];
        if (
          selectedQuestionId === "product_category" ||
          question_type === "multiselect-list"
        ) {
          if (checkedListItems.length === 0) {
            if (question.required) {
              errs.push(selectedQuestionId);
              isValid = false;
            }
          }
        } else {
          if (selectedQuestionId === "phone_number") {
            let isPhoneNumber = false;
            if (selectedQuestionVal.startsWith("+")) {
              const possiblePhoneNumber = selectedQuestionVal
                .replaceAll(" ", "")
                .slice(1);
              const isNum = /^\d+$/.test(possiblePhoneNumber);
              isPhoneNumber =
                isNum &&
                possiblePhoneNumber.length < 16 &&
                possiblePhoneNumber.length > 8;
            }
            if (!isPhoneNumber) {
              if (question.required) {
                errs.push(selectedQuestionId);
                isValid = false;
              }
            }
          }
          if (!selectedQuestionVal) {
            if (question.required) {
              errs.push(selectedQuestionId);
              isValid = false;
            }
          }
        }
      })
    );
    if (!isValid) {
      setError("");
    }
    setErrors(errs);
    return isValid;
  };

  const getCountryData = useCallback(() => {
    SignerService({
      method:"GET",
      url:identityConfig.apiBaseURL +
        `/v2/taxonomy/public/countries?locale=${identityConfig.language}`,
    }).then((response) => {
      setCountryData(response.data);
    });
  }, [identityConfig]);

  const OnCountrySelectChange = (...e) => {
    if (e.length !== 0) {
      setSelectedCountry(e[1].name);
      setSelectedCountryId(e[1].id);
      setStateData(e[1].states);
      fieldInfo["country"] = e[1].id;
      fieldInfo["country_name"] = e[1].name;
      setSelectedState("");
      setSelectedStateId("");
      var countryTypeVal = e[1].group;
      if (countryType === "A") {
        setTypeAConsentSelected(false);
      }
      setCountryType(countryTypeVal);
      const validErrors = errors.filter((error) => error !== "country");
      setErrors(validErrors);
    } else {
      setSelectedCountry("");
      setCountryType("");
    }
  };

  const OnStateSelectChange = (...e) => {
    if (e.length !== 0) {
      setSelectedStateId(e[1].id);
      setSelectedState(e[1].name);
      fieldInfo["state"] = e[1].id;
      fieldInfo["state_name"] = e[1].name;
      const validErrors = errors.filter((error) => error !== "state");
      setErrors(validErrors);
    } else {
      setSelectedState("");
      setSelectedStateId("");
    }
  };

  const handleTypeASiteConsent = (event) => {
    setTypeAConsentSelected(true);
    setTypeDConsentSelected(false);
    setFPConsentText(t("FP_consent_text"));
    if (event.target.value === "YES") {
      setFPConsent(true);
    } else if (event.target.value === "NO") {
      setFPConsent(false);
    }
    const validErrors = errors.filter((error) => error !== "Aterms");
    setErrors(validErrors);
  };

  const handleTypeBSiteConsent = (event) => {
    setFPConsentText(t("tick_here_text"));
    if (event.target.checked) {
      setFPConsent(false); // If selected means opt-out here
    } else {
      setFPConsent(true);
    }
  };

  const handleTypeDConsent = (event) => {
    setFPConsentText(t("by_continuing"));
    if (event.target.checked) {
      setTypeDConsentSelected(true);
      setTypeAConsentSelected(false);
      setFPConsent(true);
    } else {
      setTypeDConsentSelected(false);
      setTypeAConsentSelected(false);
      setFPConsent(false);
    }
  };

  useEffect(() => {
    const idT = getIIRISCookie("IRIS_IDT");
    try {
      getCognitoUser(idToken || idT).then((userAttr) => {
        setUserAttributes(userAttr);
      });
    } catch (e) {
      console.log(e);
    }
    getCountryData();
    localStorage.setItem(
      "profile_picture",
      userObj.picture ? userObj.picture : ""
    );
    setFullName(userObj.given_name + " " + userObj.family_name);

    if (userObj.identities) {
      const identities = JSON.parse(userObj.identities);
      let socialType = identities[0].providerName.toLowerCase();
      if (socialType === "signinwithapple") {
        socialType = "apple";
      }
      setSocialType(socialType);
      handleSocialFlows(socialType, userObj.email, authToken);
      try {
        const evtObj = {};
        evtObj.cat = "IRISIdentityEvent";
        evtObj.lbl = "Login Mode";
        evtObj.act = "login";
        evtObj.prop = "socialLogin";
        evtObj.val = getSocialType(identities[0].providerName.toLowerCase());
        if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
          window.IIRISTracker.trackStructEvt(evtObj);
        }
      } catch (error) {
        console.log(error);
      }
    } else if (userObj.email.startsWith("linkedin.")) {
      setSocialType("linkedin");
      handleSocialFlows(
        "linkedin",
        userObj.email.split("linkedin.")[1],
        authToken
      );
      try {
        const evtObj = {};
        evtObj.cat = "IRISIdentityEvent";
        evtObj.lbl = "Login Mode";
        evtObj.act = "login";
        evtObj.prop = "socialLogin";
        evtObj.val = getSocialType("linkedin");
        if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
          window.IIRISTracker.trackStructEvt(evtObj);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      const authToken = getIIRISCookie("IRIS_AUTH");
      const irisId = getIIRISCookie("IRIS_ID");
      if (authToken && irisId && identityConfig.show_progressive_profile) {
        setIsLoading(true);
        setPosition("fixed");
        IRISService.makeGetRequest(
          `${identityConfig.apiBaseURL}/v3/audience/registration/${irisId}/${identityConfig.id}`,
          authToken
        )
          .then((regResponse) => {
            if (regResponse.status === "success") {
              localStorage.setItem("CheckLocalUser", "NO");
              identityConfig.redirectToProfilePage();
            } else if (regResponse.status === "error") {
              setIsLoading(false);
              setPosition("static");
            }
          })
          .catch((err) => {
            setIsLoading(false);
            setPosition("static");
          });
      } else {
      }
    }
  }, []);

  const getSocialType = (social) => {
    if (social === "linkedin") {
      return 2.0;
    } else if (social === "google") {
      return 3.0;
    } else if (social === "facebook") {
      return 4.0;
    }
    return 0;
  };

  const handleSocialFlows = (socialType, socialEmail, token) => {
    try {
      const evtObj = {};
      evtObj.cat = "IRISIdentityEvent";
      evtObj.lbl = "Page Visited";
      evtObj.act = "businessEmailCheck";
      evtObj.prop = "social";
      evtObj.val = 1.0;
      if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
        window.IIRISTracker.trackStructEvt(evtObj);
      }
    } catch (error) {
      console.log(error);
    }

    setIsLoading(true);
    setPosition("fixed");

    const headers = {
      Authorization: token,
    };

    let profileinfo_payload = {
      email: socialEmail,
      profile_type: socialType,
    };
    IRISService.makePostRequest(
      `${identityConfig.apiBaseURL}/v3/audience/profileinfo`,
      profileinfo_payload,
      token
    )
      .then((socialChkResponse) => {
        if (socialChkResponse.status === "success") {
          const audienceData = socialChkResponse.data[0];
          const irisid = audienceData.id;
          //Set User to Track
          document.cookie =
            "IRIS_ID=" +
            irisid +
            "; path=/; max-age=7776000; samesite=strict; secure;domain=" +
            window.location.hostname;
          sha256(audienceData.business_email.toLowerCase()).then((hash) => {
            document.cookie =
              "IRIS_UHASH=" +
              hash +
              "; path=/; max-age=7776000; samesite=strict; secure;domain=" +
              window.location.hostname;
          });
          if (window.IIRISTracker && window.snowplow) {
            window.snowplow("setUserIdFromCookie", "IRIS_ID");
          }
          let user = {
            id: audienceData.id,
            email: audienceData.social_accounts[0].social_email,
            given_name: audienceData.first_name,
            family_name: audienceData.last_name,
            flow: "social",
            country: audienceData.country,
            country_id: selectedCountryId,
            countryType: countryType,
            state: audienceData.state,
            company: audienceData.company,
            job_function: audienceData.job_function,
            business_type: audienceData.business_type,
            status: "success",
            picture: userObj.picture ? userObj.picture : "",
            social_accounts: audienceData.social_accounts,
            job_title: audienceData.job_title,
            is_social_login: audienceData.is_social_login,
          };
          //check for user registration
          const regUri =
            identityConfig.apiBaseURL +
            "/v3/audience/registration/" +
            irisid +
            "/" +
            identityConfig.id;
          axios
            .get(regUri, { headers })
            .then(async (regResponse) => {
              if (localStorage.getItem("iiris_ust")) {
                const timeData = {};
                timeData.cat = "IRISIdentityEvent";
                timeData.lbl = "Capture Time";
                timeData.act = "loginTime";
                timeData.prop = "loginTime";
                const startTime = Date.parse(localStorage.getItem("iiris_ust"));
                const endTime = new Date();
                timeData.val = (endTime - startTime).toFixed(2);
                if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
                  window.IIRISTracker.trackStructEvt(timeData);
                }
              }
              if (regResponse.status === 200) {
                //if registration found rediret to parent
                if (
                  !userObj["custom:business_email"] &&
                  identityConfig.cognito_add_business_email_attr
                ) {
                  const isLinkedInLogin = socialEmail.startsWith("linkedin.");
                  await updateCognitoAttribute(
                    audienceData.business_email,
                    isLinkedInLogin,
                    isLinkedInLogin
                      ? socialEmail.split("linkedin.")[1]
                      : socialEmail
                  );
                }
                if (identityConfig.persist_session === false) {
                  clearIRISCookies();
                }
                if (window.irisLoginCallback) {
                  let callbackUrl = "";
                  if (!identityConfig.show_progressive_profile) {
                    callbackUrl = `${identityConfig.apiBaseURL}/v3/audience/profile/${audienceData.id}`;
                  } else {
                    callbackUrl = `${identityConfig.apiBaseURL}/v3/audience/profile/${audienceData.id}/${identityConfig.id}`;
                  }
                  IRISService.makeGetRequest(callbackUrl, authToken)
                    .then((res) => {
                      if (res.status === "success") {
                        let userData = res.data[0];
                        userData.profile_picture = userObj.picture
                          ? userObj.picture
                          : "";
                        userData.is_social_login = JSON.parse(
                          localStorage.getItem("is_social_login")
                        );
                        const loginCallBackObj = {
                          success: true,
                          user: userData,
                          token: authToken,
                        };
                        window.irisLoginCallback(loginCallBackObj);
                      } else if (res.status === "error") {
                        const loginCallBackObj = {
                          success: false,
                          user: null,
                          token: null,
                        };
                        window.irisLoginCallback(loginCallBackObj);
                      }
                    })
                    .catch((err) => {
                      const loginCallBackObj = {
                        success: false,
                        user: null,
                        token: null,
                      };
                      window.irisLoginCallback(loginCallBackObj);
                    });
                }
                localStorage.setItem("CheckLocalUser", "NO");
                identityConfig.redirectToProfilePage();
              }
            })
            .catch((error) => {
              setIsLoading(false);
              setPosition("static");
              if (error.response) {
                if (error.response.status === 404) {
                  //show progressive profile screen
                  setUserObj(user);
                  setIsLoading(false);
                  setPosition("static");
                }
              } else {
                setIsLoading(false);
                setPosition("static");
              }
            });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setPosition("static");
      });
  };

  const clearIRISCookies = () => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      if (name.indexOf("IRIS_") >= 0) {
        document.cookie =
          name +
          "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" +
          window.location.hostname;
      }
    }
  };

  const [questionSelection, setQuestionSelection] = useState(() => {
    return pages.map((page, index) => {
      return {
        [`page${index + 1}`]: page.questions.map((question) => {
          let profile_id = question.profile_id
            ? question.profile_id
            : question.id;
          const questionObj = {};
          questionObj.id = profile_id;
          if (question.hasOwnProperty("isCompany")) {
            questionObj.isCompany = true;
            questionObj.company_fields = question.company_fields;
          }
          if (question.hasOwnProperty("isRole")) {
            questionObj.isRole = true;
          }
          questionObj[profile_id] = "";
          questionObj["required"] =
            question.required != undefined ? question.required : true;
          questionObj.type = question.type ? question.type : "";
          return questionObj;
        }),
      };
    });
  });

  const { cols: gridCols, rows: gridRows } = useMemo(
    () =>
      pages[pageNumber - 1].questions.reduce(
        (res, question) => ({
          rows:
            res.rows > question.layout.rows ? res.rows : question.layout.rows,
          cols:
            res.cols > question.layout.cols ? res.cols : question.layout.cols,
        }),
        { rows: 0, cols: 0 }
      ),
    [pages]
  );

  let orderedQuestions = useMemo(
    () =>
      pages[pageNumber - 1].questions
        .slice()
        .sort((prev, next) =>
          prev.layout.rows !== next.layout.rows
            ? prev.layout.rows - next.layout.rows
            : prev.layout.cols - next.layout.cols
        ),
    [pages]
  );

  useEffect(() => {
    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy.forEach((page, index) => {
        page[`page${index + 1}`].forEach((question) => {
          let profile_id = question.profile_id
            ? question.profile_id
            : question.id;
          if (question.hasOwnProperty("isCompany")) {
            if (question.company_fields.type === "array") {
              const value = get(
                companyData[userDomain],
                question.company_fields.key_name
              );
              question[profile_id] = value ? value[0] : "";
            } else if (question.company_fields.type === "string") {
              const value = get(
                companyData[userDomain],
                question.company_fields.key_name
              );
              question[profile_id] = value ? value.toString() : "";
            }
          }
        });
      });
      return prevStateCopy;
    });
  }, [companyData, userDomain]);

  const getQuestionData = useCallback(async () => {
    pages.map((page, index) => {
      page.questions.map(async (question, i) => {
        let profile_id = question.profile_id
          ? question.profile_id
          : question.id;
        if (question.fetch === "dynamic") {
          try {
            const response = await SignerService({
              method:"GET",
              url:identityConfig.apiBaseURL +
                "/" +
                question.url.replace("{division}/{brand}", "") +
                identityConfig.division +
                "/" +
                identityConfig.brand +
                "?locale=" +
                language,
          });
            const questionId = profile_id;
            setQuestionData((prevState) => {
              const newData = {
                ...prevState,
                [`page${index + 1}`]: {
                  ...prevState[`page${index + 1}`],
                  [questionId]: response.data ? response.data : response,
                },
              };
              return newData;
            });
            setFilteredQuestionData((prevState) => {
              const newData = {
                ...prevState,
                [`page${index + 1}`]: {
                  ...prevState[`page${index + 1}`],
                  [questionId]: response.data ? response.data : response,
                },
              };
              return newData;
            });
          } catch (e) {
            console.log(e);
          }
        } else if (question.fetch === "static") {
          const questionId = profile_id;
          setQuestionData((prevState) => {
            const newData = {
              ...prevState,
              [`page${index + 1}`]: {
                ...prevState[`page${index + 1}`],
                [questionId]: getLocalizedData(question.data),
              },
            };
            return newData;
          });
          setFilteredQuestionData((prevState) => {
            const newData = {
              ...prevState,
              [`page${index + 1}`]: {
                ...prevState[`page${index + 1}`],
                [questionId]: getLocalizedData(question.data),
              },
            };
            return newData;
          });
        }
      });
      return null;
    });
  }, [
    identityConfig.brand,
    identityConfig.division,
    identityConfig.apiBaseURL,
    pages,
  ]);

  useEffect(() => {
    getQuestionData();
    window.scrollTo(0, 0);
  }, [getQuestionData]);

  function hasError(key) {
    return errors.indexOf(key) !== -1;
  }

  const getLocalizedData = (data) => {
    let localizedData = [];
    const locale = language;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].locale && locale === "en") {
          localizedData.push(data[i]);
        } else if (data[i].locale && data[i].locale === locale) {
          localizedData.push(data[i]);
        }
      }
    }
    return localizedData;
  };

  const finishSignUp = async () => {
    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    setPosition("fixed");
    let socialHandleDetails = userAttributes.identities ? JSON.parse(userAttributes.identities)[0] : undefined;

    let first_name = "";
    let last_name = "";

    if (userObj.identities) {
      const identities = JSON.parse(userObj.identities);
      const socialType = identities[0].providerName.toLowerCase();
      if (!userObj.family_name) {
        first_name = userObj.given_name;
        last_name = familyNameInputRef.current.value;
      } else {
        first_name = userObj.given_name;
        last_name = userObj.family_name;
      }
    } else {
      first_name = userObj.given_name;
      last_name = userObj.family_name;
    }

    let payload = {
      business_email: emailInputRef.current.value,
      first_name,
      last_name,
      company: "",
      product_ids: [identityConfig.id],
      country: selectedCountryId,
      country_name: selectedCountry,
      state: selectedStateId,
      state_name: selectedState,
      is_social_login: true,
      business_type: "",
      job_function: "",
      job_title: "",
      social_accounts: [
        {
          social_type: socialType,
          social_email: userObj.email.startsWith("linkedin.")
            ? userObj.email.split("linkedin.")[1]
            : userObj.email,
          profile_picture: userObj.picture ? userObj.picture : "",
        },
      ],
    };

    if (socialHandleDetails !== undefined) {
      if (socialHandleDetails.providerName === "Google") {
        payload.google_id =
          socialHandleDetails.providerName + "_" + socialHandleDetails.userId;
      } else if (socialHandleDetails.providerName === "Facebook") {
        payload.facebook_id =
          socialHandleDetails.providerName + "_" + socialHandleDetails.userId;
      } else if (socialHandleDetails.providerName === "Linkedin") {
        payload.linkedin_id =
          socialHandleDetails.providerName + "_" + socialHandleDetails.userId;
      }
    }

    IRISService.makePostRequest(
      identityConfig.apiBaseURL + "/v3/audience/profile",
      payload,
      authToken
    )
      .then(async (audResponse) => {
        if (audResponse.status === "success") {
          try {
            //Tracker Sign Up Event for Sign Up
            const transactionID =
              window.localStorage.getItem("regTransactionId");
            const evt = {
              entityId: "NA",
              transactionId: transactionID,
              formId: "registration",
              status: "page1submit-social",
              type: "register",
              ts: new Date().toISOString(),
            };
            const asset = {
              id: "NA",
              name: window.location.host,
              type: "form",
              size: 0,
              url: window.location.href,
              created: new Date().toISOString(),
              lastUpdated: new Date().toISOString(),
              tags: "SignUp",
              metadata: JSON.stringify(payload),
            };
            trackBusinessEvt(evt, asset);
          } catch (error) {
            console.log(error);
          }
          const data = audResponse.data[0];
          let user = {
            id: data.id,
            email: data.business_email,
            given_name: data.first_name,
            family_name: data.last_name,
            flow: "social",
            country: data.country,
            country_id: selectedCountryId,
            product_ids: data.product_ids,
            country_name: data.country_name,
            countryType: countryType,
            state: data.state,
            state_name: data.state_name,
            company: data.company,
            job_function: data.job_function,
            business_type: data.business_type,
            status: "success",
            picture: userObj.picture ? userObj.picture : "",
            social_accounts: data.social_accounts,
            job_title: data.job_title,
            is_social_login: data.is_social_login,
          };
          document.cookie =
            "IRIS_ID=" +
            user.id +
            "; path=/; max-age=7776000; samesite=strict; secure;domain=" +
            window.location.hostname;
          sha256(user.email.toLowerCase()).then((hash) => {
            document.cookie =
              "IRIS_UHASH=" +
              hash +
              "; path=/; max-age=7776000; samesite=strict; secure;domain=" +
              window.location.hostname;
          });
          if (window.IIRISTracker && window.snowplow) {
            window.snowplow("setUserIdFromCookie", "IRIS_ID");
          }
          handleConsent(authToken, user);
          try {
            let regPayload = {
              iris_id: data.id,
              product_id: identityConfig.id,
              product_type: identityConfig.siteType,
              product_sub_type: identityConfig.siteSubType,
              product_name: identityConfig.siteName,
              user_enroll_date: new Date(),
              questions: {
                user_enroll_type:
                  language === "en"
                    ? identityConfig.welcome_email_template
                    : identityConfig.welcome_email_template + "_" + language,
              },
              mode: identityConfig.environment_mode,
            };

            const rolesPayload = {
              product_id: identityConfig.id,
              iris_id: userObj.id,
              business_email: data.business_email,
              questions: {},
              product_type: identityConfig.siteType,
              product_sub_type: identityConfig.siteSubType,
              product_name: identityConfig.siteName,
            };
            let payload = {
              business_email: data.business_email,
              first_name: data.first_name,
              last_name: data.last_name,
              country: userObj.country_id
                ? userObj.country_id
                : userObj.country,
              country_name: userObj.country_name,
              state: userObj.state,
              state_name: userObj.state_name,
              is_social_login: userObj.is_social_login,
              social_accounts: userObj.social_accounts,
            };
            questionSelection.map((page, index) =>
              page[`page${index + 1}`].map((question) => {
                let profile_id = question.profile_id
                  ? question.profile_id
                  : question.id;
                const selectedQuestionId = profile_id;
                const selectedQuestionVal = question[profile_id];
                if (question.hasOwnProperty("isRole")) {
                  rolesPayload.questions[selectedQuestionId] =
                    selectedQuestionVal;
                }
                let filteredOrderedQuestion = orderedQuestions.filter((obj) => {
                  return obj.id == selectedQuestionId;
                });
                if (
                  "render" in filteredOrderedQuestion[0]
                    ? filteredOrderedQuestion[0]["render"]
                    : true
                ) {
                  if (selectedQuestionId === "job_function") {
                    payload["job_functions"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["job_functions"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else if (selectedQuestionId === "business_type") {
                    payload["business_types"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["business_types"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else if (selectedQuestionId === "product_category") {
                    payload["product_categories"] = [
                      {
                        categories: checkedListItems,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["product_categories"] = [
                      {
                        categories: checkedListItems,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else if (selectedQuestionId === "property_category") {
                    payload["property_categories"] = [
                      {
                        categories: checkedListItems,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["property_categories"] = [
                      {
                        categories: checkedListItems,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else if (selectedQuestionId === "phone_number") {
                    payload["phones"] = [
                      selectedQuestionVal.replaceAll(" ", ""),
                    ];
                  } else if (selectedQuestionId === "industry") {
                    payload["industries"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["industries"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else if (selectedQuestionId === "market_sectors") {
                    payload["market_sectors"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["market_sectors"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else if (selectedQuestionId === "interests") {
                    payload["interests"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                    regPayload.questions["interests"] = [
                      {
                        id: selectedQuestionVal,
                        division: identityConfig.division,
                        brand: identityConfig.brand,
                      },
                    ];
                  } else {
                    if (isAudienceQuestion(selectedQuestionId)) {
                      payload[selectedQuestionId] = selectedQuestionVal;
                    }
                    regPayload.questions[selectedQuestionId] =
                      selectedQuestionVal;
                  }
                }
              })
            );
            await IRISService.makePostRequest(
              identityConfig.apiBaseURL + "/v3/audience/registration",
              regPayload,
              authToken
            );
            if (configureRoles) {
              await IRISService.makePostRequest(
                identityConfig.apiBaseURL + "/v1/roles",
                rolesPayload,
                authToken
              );
            }

            if (userObj.id && userObj.id !== "") {
              payload.id = userObj.id;
            }
            try {
              const response = await IRISService.makePostRequest(
                identityConfig.apiBaseURL + "/v3/audience/profile",
                payload,
                authToken
              );
              if (response.status === "success") {
                try {
                  //Tracker Profile Submit Event for Sign Up
                  const transactionID =
                    window.localStorage.getItem("regTransactionId");
                  const evt = {
                    entityId: "NA",
                    transactionId: transactionID,
                    formId: "progressive",
                    status: "page2submit",
                    type: "register",
                    ts: new Date().toISOString(),
                  };
                  const asset = {
                    id: "NA",
                    name: window.location.host,
                    type: "form",
                    size: 0,
                    url: window.location.href,
                    created: new Date().toISOString(),
                    lastUpdated: new Date().toISOString(),
                    tags: "success",
                    metadata: JSON.stringify(payload),
                  };
                  trackBusinessEvt(evt, asset);
                } catch (error) {
                  console.log(error);
                }
                if (localStorage.getItem("iiris_ust")) {
                  const timeData = {};
                  timeData.cat = "IRISIdentityEvent";
                  timeData.lbl = "Capture Time";
                  timeData.act = "registrationTime";
                  timeData.prop = "registrationTime";
                  const startTime = Date.parse(
                    localStorage.getItem("iiris_ust")
                  );
                  const endTime = new Date();
                  timeData.val = (endTime - startTime).toFixed(2);
                  if (
                    window.IIRISTracker &&
                    window.IIRISTracker.trackStructEvt
                  ) {
                    window.IIRISTracker.trackStructEvt(timeData);
                  }
                }
                if (identityConfig.persist_session === false) {
                  clearIRISCookies();
                }
                if (window.irisRegisterCallback) {
                  IRISService.makeGetRequest(
                    `${identityConfig.apiBaseURL}/v3/audience/profile/${response.data[0].id}/${identityConfig.id}`,
                    authToken
                  )
                    .then((res) => {
                      if (res.status === "success") {
                        let userCallbackdata = res.data[0];
                        userCallbackdata.profile_picture = localStorage.getItem(
                          "profile_picture"
                        )
                          ? localStorage.getItem("profile_picture")
                          : "";
                        userCallbackdata.is_social_login = JSON.parse(
                          localStorage.getItem("is_social_login")
                        );
                        const regCallBackObj = {
                          success: true,
                          user: userCallbackdata,
                          token: authToken,
                        };
                        window.irisRegisterCallback(regCallBackObj);
                      } else if (res.status === "error") {
                        const regCallBackObj = {
                          success: false,
                          user: null,
                          token: null,
                        };
                        window.irisRegisterCallback(regCallBackObj);
                      }
                    })
                    .catch((err) => {
                      const regCallBackObj = {
                        success: false,
                        user: null,
                        token: null,
                      };
                      window.irisRegisterCallback(regCallBackObj);
                    });
                }
                localStorage.setItem("CheckLocalUser", "NO");
                localStorage.removeItem("widget_screen");
                
                identityConfig.toggleModal();
                
              } else if (response.status === "error") {
                setIsLoading(false);
                setPosition("static");
                setError(response.message);
                localStorage.removeItem("widget_screen");
                clearIRISCookies();
              }
            } catch (e) {
              console.log(e);
              setIsLoading(false);
              setPosition("static");
              setError(e.message);
              clearIRISCookies();
            }
          } catch (authError) {
            console.log(authError);
            setIsLoading(false);
            setPosition("static");
            setError(t("error_registration"));
            clearIRISCookies();
          }
          setIsLoading(false);
          setPosition('static');
        } else if (response.status === "error") {
          setIsLoading(false);
          setPosition('static');
          setError(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
        setPosition("static");
        setError("Unable to create user profile.");
        clearIRISCookies();
      });
  };

  const handleChipClick = (questionId, selectedChip, index) => {
    filterQuestionsData(questionId, [selectedChip], index);
    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        selectedChip.id;
      if (selectedChip.id) {
        const validErrors = errors.filter((error) => error !== questionId);
        setErrors(validErrors);
      } else {
        setErrors([...errors, questionId]);
      }
      return prevStateCopy;
    });
  };

  const handleTextInputChange = (questionId, val, index) => {
    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        val;
      if (val) {
        const validErrors = errors.filter((error) => error !== questionId);
        setErrors(validErrors);
      } else {
        setErrors([...errors, questionId]);
      }
      return prevStateCopy;
    });
  };

  const onDropdownChange = (questionId, e, index) => {
    filterQuestionsData(questionId, e, index);

    if (e.length !== 0) {
      setQuestionSelection((prevState) => {
        const prevStateCopy = JSON.parse(JSON.stringify(prevState));
        prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
          e[0].id;
        const validErrors = errors.filter((error) => error !== questionId);
        setErrors(validErrors);
        return prevStateCopy;
      });
    } else {
      setQuestionSelection((prevState) => {
        const prevStateCopy = JSON.parse(JSON.stringify(prevState));
        prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
          "";
        setErrors([...errors, questionId]);
        return prevStateCopy;
      });
    }
  };

  const handleCheckboxChange = (questionId, event, index) => {
    filterQuestionsData(questionId, event, index);

    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        event.target.checked;
      return prevStateCopy;
    });
  };

  const handleRadioButton = (questionId, event, index) => {
    filterQuestionsData(questionId, event, index);

    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        event.target.value;
      return prevStateCopy;
    });
  };

  function filterArrayDataByValue(arr, filterConstraint, question_id) {
    let data = arr.filter((obj) => {
      return (
        obj.parentId === question_id &&
        obj.parentValue.split(",").includes(filterConstraint.id)
      );
    });

    return data;
  }

  // Dependent Prompts Logic: Function to filter questions data
  const filterQuestionsData = (questionID, selectedId, index) => {
    let questionConfigs = pages[pageNumber - 1].questions.find(
      (o) => o.id === questionID
    );
    let selectedPage = "page" + pageNumber;

    if ("children" in questionConfigs && questionConfigs.children.length != 0) {
      let questionsToFilter = questionConfigs.children;
      for (let i = 0; i < questionsToFilter.length; i++) {
        let filteredData = filterArrayDataByValue(
          questionData[selectedPage][questionsToFilter[i]],
          selectedId[0],
          questionID
        );
        Object.keys(filteredQuestionData[selectedPage]).forEach((item) => {
          if (item == questionsToFilter[i]) {
            filteredQuestionData[selectedPage][item] = filteredData;
          }
        });

        //  Render the dependent questions by changing render property.
        let filteredOrderedQuestion = orderedQuestions.filter((obj) => {
          return obj.id == questionsToFilter[i];
        });
        if (
          "render" in filteredOrderedQuestion[0] &&
          filteredOrderedQuestion[0]["data"] &&
          checkIfParentValueContainsSelectedID(
            filteredOrderedQuestion[0]["data"],
            selectedId[0].id
          )
        ) {
          filteredOrderedQuestion[0]["render"] = true;
        } else if ("render" in filteredOrderedQuestion[0]) {
          filteredOrderedQuestion[0]["render"] = false;
        }

        // Reset the children question selections
        let filteredQuestionSelection = questionSelection[pageNumber - 1][
          selectedPage
        ].filter((obj) => {
          return obj.id == questionsToFilter[i];
        });
        if (questionsToFilter[i] in filteredQuestionSelection[0]) {
          filteredQuestionSelection[0][questionsToFilter[i]] = "";
        }

        // Reset the multi-select children question selection if any
        if (
          questionsToFilter[i] in questionData[selectedPage] &&
          orderedQuestions.filter((obj) => {
            return obj.id == questionsToFilter[i];
          })[0]["type"] == "multiselect-list"
        ) {
          setCheckedListItems([]);
        }
      }
    }
  };

  const checkIfParentValueContainsSelectedID = (data, selectedId) => {
    let isIdSelected = false;

    data.forEach((obj) => {
      const parentValueArr = obj.parentValue.split(",");
      parentValueArr.forEach((val) => {
        if (val.trim() === selectedId) {
          isIdSelected = true;
          return;
        }
      });
      if (isIdSelected) {
        return;
      }
    });

    return isIdSelected;
  };

  const createImageFromInitials = (size, name, color) => {
    if (name == null) {
      return;
    }
    name = getInitials(name);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = canvas.height = size;
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, size, size);
    context.fillStyle = `${color}50`;
    context.fillRect(0, 0, size, size);
    context.fillStyle = color;
    context.textBaseline = "middle";
    context.textAlign = "center";
    context.font = `${size / 2}px Arial`;
    context.fillText(name, size / 2, size / 2);
    return canvas.toDataURL();
  };

  const getInitials = (name) => {
    let initials;
    const nameSplit = name.split(" ");
    const nameLength = nameSplit.length;
    if (nameLength > 1) {
      initials =
        nameSplit[0].substring(0, 1) +
        nameSplit[nameLength - 1].substring(0, 1);
    } else if (nameLength === 1) {
      initials = nameSplit[0].substring(0, 1);
    } else {
      return;
    }
    return initials.toUpperCase();
  };

  // Add/Remove checked item from list
  const handleListCheck = (event) => {
    let updatedList = [...checkedListItems];

    if (event.target.checked) {
      updatedList = [...checkedListItems, { id: event.target.value }];
    } else {
      updatedList = checkedListItems.filter(
        (listItem) => listItem.id !== event.target.value
      );
    }
    setCheckedListItems(updatedList);
  };

  const handlePageClick = (e, type) => {
    e.preventDefault();
    if (type === "prev") {
      setPageNumber((prevState) => prevState - 1);
    }
    if (type === "next") {
      setPageNumber((prevState) => prevState + 1);
    }
  };

  const getQuestionTitle = (question) => {
    if (question.hasOwnProperty("config")) {
      const filteredQuestionArray = question.config.filter(
        (configObj) =>
          configObj.brand === brand &&
          configObj.division === division &&
          configObj.locale === language
      );
      if (filteredQuestionArray.length > 0) {
        return filteredQuestionArray[0].title;
      } else {
        return question.title || "";
      }
    } else {
      return question.title || "";
    }
  };

  const isAudienceQuestion = (questionId) => {
    let flag = false;
    const questions = pages[0].questions;
    questions.map((que) => {
      let profile_id = que.profile_id ? que.profile_id : que.id;
      if (profile_id === questionId) {
        if (que.isAudience) {
          flag = true;
          return flag;
        }
      }
    });
    return flag;
  };
  return (
    <div>
      {isLoading && (
        <div className={classes["iiris-loading-container"]}>
          <LoadingContent />
        </div>
      )}
      {!isLoading && !isLocalUser && (
        <div className={`${classes["iiris-work-email-form"]}`}>
          <form method="post" autoComplete="off">
            <div className="iiris-text-center">
              <img
                src={
                  profilePic !== ""
                    ? profilePic
                    : createImageFromInitials(80, fullName, "#11A7D9")
                }
                alt="Avatar"
                class={classes["avatar"]}
              />
            </div>

            <h4 className="iiris-text-center">
              {t("welcome")} {userObj.given_name} {userObj.family_name}!
            </h4>

            <div className="iiris-form-group iiris-text-center">
              {t("please_verify")}
            </div>

            <div
              className={classes["iiris-error-space"]}
              style={{ display: error.length > 0 ? "block" : "none" }}
            >
              {error}
            </div>
            <div style={{ border: "1px solid gray", borderRadius: "6px" }}>
              <h4
                style={{
                  borderBottom: "1px solid gray",
                  padding: "0.65rem 1.3rem",
                }}
              >
                Personal Details
              </h4>
              {(socialType && (!userObj.family_name)) && (
                <>
                <div className={classes["iiris-form-container-custom"]}>
                  <div className={classes["iiris-form-group"]} style={{width: '100%'}}>
                    <label className={classes["iiris-form-label"]}>
                      {t("last_name")}
                    </label>
                    <label
                      id="red-text"
                      style={{ color: "red", marginLeft: "3px" }}
                    >
                      *
                    </label>
                    <div className="iiris-input-group">
                      <input
                        type="text"
                        className={`iiris-form-control${
                          errors.includes("familyNameInputRef")
                            ? ` ${classes["error-border"]}`
                            : ""
                        }`}
                        id="familyNameInputRef"
                        name="family_name"
                        required="required"
                        maxlength="120"
                        ref={familyNameInputRef}
                        onChange={(e) => validateField(e.target)}
                      />
                    </div>
                    <div
                      id="error-text"
                      className={
                        classes[
                        hasError("familyNameInputRef")
                          ? "iiris-error-space"
                          : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_last")}
                    </div>
                  </div>
                  </div>
                </>
              )}
              <div className={classes["iiris-form-container-custom"]}>
                <div className={classes["iiris-form-group"]}>
                  <label className={classes["iiris-form-label"]}>
                    {t("personal_email")}
                  </label>
                  <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                  <div className="iiris-form-group">
                    <input
                      type="text"
                      className="iiris-form-control"
                      name="email"
                      required="required"
                      defaultValue={userObj?.email}
                      disabled
                    />
                  </div>
                </div>
                <div className={classes["iiris-form-group"]}>
                  <label className={classes["iiris-form-label"]}>
                    {t("business_email")}
                  </label>
                  <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                  <div className="iiris-input-group">
                    <input
                      type="text"
                      className={`iiris-form-control${
                        errors.includes("emailInputRef")
                          ? ` ${classes["error-border"]}`
                          : ""
                      }`}
                      name="email"
                      id="emailInputRef"
                      required="required"
                      ref={emailInputRef}
                      onChange={(e) => {
                        validateField(e.target);
                      }}
                    />
                  </div>
                  <div
                    className={
                      classes[
                        hasError("emailInputRef")
                          ? "iiris-error-space"
                          : "iiris-hidden"
                      ]
                    }
                  >
                    {t("valid_email")}
                  </div>
                </div>
              </div>
              <div className={classes["iiris-form-container-custom"]}>
                <div className={classes["iiris-form-group"]}>
                  <label className={classes["iiris-form-label"]}>
                    {t("country")}
                  </label>
                  <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                  <div
                    className={`${classes["transparent-border"]}${
                      errors.includes("country")
                        ? ` ${classes["error-border"]}`
                        : "normal-border"
                    }`}
                  >
                    <CustomSelectComponent
                      isDisabled={false}
                      text={t("select_country")}
                      data={countryData}
                      OnChange={OnCountrySelectChange}
                      isSearchable={true}
                      label="name"
                      value="name"
                      position="bottom"
                      customPosition={true}
                      selectedValue={selectedCountry}
                    />
                  </div>
                  <div
                    className={
                      classes[
                        hasError("country")
                          ? "iiris-error-space"
                          : "iiris-hidden"
                      ]
                    }
                  >
                    {t("please_country")}
                  </div>
                </div>
                <div className={classes["iiris-form-group"]}>
                  <label className={classes["iiris-form-label"]}>
                    {t("state")}
                  </label>
                  {(selectedCountryId === "US" ||
                    selectedCountryId === "CA" ||
                    selectedCountryId === "BR") && (
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                  )}
                  <div
                    className={`${classes["transparent-border"]}${
                      errors.includes("state")
                        ? ` ${classes["error-border"]}`
                        : "normal-border"
                    }`}
                  >
                    <CustomSelectComponent
                      isDisabled={stateData.length === 0 ? true : false}
                      text={
                        stateData.length === 0
                          ? t("not_applicable")
                          : t("select_state")
                      }
                      data={stateData}
                      OnChange={OnStateSelectChange}
                      isSearchable={true}
                      label="name"
                      value="name"
                      position="bottom"
                      customPosition={true}
                      selectedValue={selectedState}
                    />
                  </div>
                  <div
                    className={
                      classes[
                        hasError("state") ? "iiris-error-space" : "iiris-hidden"
                      ]
                    }
                  >
                    {t("please_state")}
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                border: "1px solid gray",
                borderRadius: "6px",
                marginTop: "2rem",
              }}
            >
              <h4
                style={{
                  borderBottom: "1px solid gray",
                  padding: "0.65rem 1.3rem",
                }}
              >
                Business Details
              </h4>
              <div
                className={classes["iiris-formItemsContainer"]}
                style={{
                  gridTemplateRows: `repeat(1, 1fr)`,
                  gridTemplateColumns: `repeat(1, 1fr)`,
                }}
              >
                {orderedQuestions.map((question, index, questions) => {
                  let profile_id = question.profile_id
                    ? question.profile_id
                    : question.id;
                  return (
                    <div
                      key={profile_id}
                      className={classes["iiris-form-container-custom"]}
                      style={{
                        gridColumnStart: Number(question.layout.cols),
                        gridColumnEnd:
                          questions[index + 1]?.layout?.rows ===
                          question.layout.rows
                            ? questions[index + 1].layout.cols
                            : Number(gridCols) + 1,
                        gridRowStart: Number(question.layout.rows),
                        gridRowEnd: Number(question.layout.rows) + 1,
                      }}
                    >
                      <div className="iiris-form-group" style={{ flexGrow: 1 }}>
                        {question.type !== "checkbox" &&
                          ("render" in question ? question.render : true) && (
                            <label className={classes["iiris-form-label"]}>
                              {getQuestionTitle(question)}:
                            </label>
                          )}

                        {question.required === true &&
                          ("render" in question ? question.render : true) && (
                            <label style={{ color: "red", marginLeft: "3px" }}>
                              *
                            </label>
                          )}

                        {question.type === "chips" &&
                          !question.config
                            .filter(
                              (configObj) =>
                                configObj.brand === brand &&
                                configObj.division === division &&
                                configObj.locale === language
                            )[0]
                            ?.hasOwnProperty("type") &&
                          ("render" in question ? question.render : true) && (
                            <>
                              <div className={classes["iiris-chips"]}>
                                <div className={classesMat.root}>
                                  {filteredQuestionData[`page${pageNumber}`] &&
                                    filteredQuestionData[`page${pageNumber}`][
                                      profile_id
                                    ]?.map((bType) => (
                                      <Chip
                                        className={
                                          questionSelection[pageNumber - 1][
                                            `page${pageNumber}`
                                          ][index][profile_id] === bType.id
                                            ? classes["iiris-chipSelected"]
                                            : classes[""]
                                        }
                                        variant="outlined"
                                        size="large"
                                        icon={
                                          <Icon
                                            icon={bType.icon}
                                            color={bType.color}
                                            height="23"
                                            width="23"
                                          />
                                        }
                                        label={bType.name}
                                        onClick={() => {
                                          handleChipClick(
                                            profile_id,
                                            bType,
                                            index
                                          );
                                        }}
                                      />
                                    ))}
                                </div>
                              </div>
                              <div
                                className={
                                  classes[
                                    hasError(profile_id)
                                      ? "iiris-error-space"
                                      : "iiris-hidden"
                                  ]
                                }
                              >
                                {t("please_select")}{" "}
                                {getQuestionTitle(question).toLowerCase()}
                              </div>
                            </>
                          )}

                        {question.type === "multiselect-list" &&
                          ("render" in question ? question.render : true) && (
                            <>
                              <div
                                style={{
                                  border: "1px solid #ced4da",
                                  borderRadius: ".25rem",
                                }}
                              >
                                <div
                                  className={classes["iiris-list-container"]}
                                >
                                  {filteredQuestionData[`page${pageNumber}`] &&
                                    filteredQuestionData[`page${pageNumber}`][
                                      profile_id
                                    ]?.map((item, index) => (
                                      <div key={index}>
                                        <input
                                          value={item.id}
                                          type="checkbox"
                                          onChange={handleListCheck}
                                          checked={checkedListItems
                                            .map((item) => item.id)
                                            .includes(item.id)}
                                        />
                                        <span style={{ marginLeft: "10px" }}>
                                          {item.name}
                                        </span>
                                      </div>
                                    ))}
                                </div>
                              </div>
                              <div
                                className={
                                  classes[
                                    hasError(profile_id)
                                      ? "iiris-error-space"
                                      : "iiris-hidden"
                                  ]
                                }
                              >
                                {t("please_select")}{" "}
                                {getQuestionTitle(question).toLowerCase()}
                              </div>
                            </>
                          )}
                        {question.type === "text" &&
                          profile_id !== "company" &&
                          ("render" in question ? question.render : true) && (
                            <>
                              <input
                                type="text"
                                className={`iiris-form-control${
                                  errors.includes(profile_id)
                                    ? ` ${classes["error-border"]}`
                                    : " normal-border"
                                }`}
                                name={profile_id}
                                maxlength="120"
                                value={
                                  questionSelection[pageNumber - 1][
                                    `page${pageNumber}`
                                  ][index][profile_id]
                                }
                                onChange={(e) =>
                                  handleTextInputChange(
                                    profile_id,
                                    e.target.value,
                                    index
                                  )
                                }
                                style={{ fontSize: "14px" }}
                              />
                              <div
                                className={
                                  classes[
                                    hasError(profile_id)
                                      ? "iiris-error-space"
                                      : "iiris-hidden"
                                  ]
                                }
                              >
                                {t("please_enter")}{" "}
                                {getQuestionTitle(question).toLowerCase()}
                              </div>
                            </>
                          )}

                        {question.type === "text" &&
                          profile_id === "company" &&
                          ("render" in question ? question.render : true) && (
                            <div className={classes["iiris-clearable-input"]}>
                              <TextInput
                                value={
                                  questionSelection[pageNumber - 1][
                                    `page${pageNumber}`
                                  ][index][profile_id]
                                }
                                className={`iiris-form-control${
                                  errors.includes(profile_id)
                                    ? ` ${classes["error-border"]}`
                                    : " normal-border"
                                }`}
                                trigger=""
                                Component="input"
                                options={
                                  companyData["informa.com"]?.company?.aliases
                                }
                                onChange={(val) =>
                                  handleTextInputChange(profile_id, val, index)
                                }
                              />
                              <div
                                className={
                                  classes[
                                    hasError(profile_id)
                                      ? "iiris-error-space"
                                      : "iiris-hidden"
                                  ]
                                }
                              >
                                {t("please_enter")}{" "}
                                {getQuestionTitle(question).toLowerCase()}
                              </div>
                            </div>
                          )}

                        {(question.type === "dropdown" ||
                          (question.config
                            ?.filter(
                              (configObj) =>
                                configObj.brand === brand &&
                                configObj.division === division &&
                                configObj.locale === language
                            )[0]
                            ?.hasOwnProperty("type") &&
                            question.config.filter(
                              (configObj) =>
                                configObj.brand === brand &&
                                configObj.division === division &&
                                configObj.locale === language
                            )[0].type === "dropdown")) &&
                          ("render" in question ? question.render : true) && (
                            <>
                              <div
                                className={`${classes["transparent-border"]}${
                                  errors.includes(profile_id)
                                    ? ` ${classes["error-border"]}`
                                    : "normal-border"
                                }`}
                              >
                                <CustomSelectComponent
                                  isDisabled={false}
                                  text={
                                    questionSelection[pageNumber - 1][
                                      `page${pageNumber}`
                                    ][index][profile_id]
                                  }
                                  data={
                                    filteredQuestionData[`page${pageNumber}`]
                                      ? filteredQuestionData[
                                          `page${pageNumber}`
                                        ][profile_id]
                                      : []
                                  }
                                  OnChange={(e) =>
                                    onDropdownChange(profile_id, e, index)
                                  }
                                  isSearchable={true}
                                  label="name"
                                  value="name"
                                  position="bottom"
                                  customPosition={false}
                                />
                              </div>
                              <div
                                className={
                                  classes[
                                    hasError(profile_id)
                                      ? "iiris-error-space"
                                      : "iiris-hidden"
                                  ]
                                }
                              >
                                {t("please_select")}{" "}
                                {getQuestionTitle(question).toLowerCase()}
                              </div>
                            </>
                          )}

                        {question.type === "checkbox" &&
                          ("render" in question ? question.render : true) && (
                            <>
                              <input
                                type="checkbox"
                                className={classes["iiris-checkbox-style"]}
                                onClick={(e) =>
                                  handleCheckboxChange(profile_id, e, index)
                                }
                              />
                              <span>{getQuestionTitle(question)}</span>
                            </>
                          )}

                        {question.type === "radio-button" &&
                          ("render" in question ? question.render : true) && (
                            <>
                              <div>
                                {filteredQuestionData[`page${pageNumber}`] &&
                                  filteredQuestionData[`page${pageNumber}`][
                                    profile_id
                                  ]?.map((item) => (
                                    <div>
                                      <input
                                        value={item.name}
                                        name="iris-radio-button-question"
                                        className={classes["iiris-form-label"]}
                                        type="radio"
                                        id={item.id}
                                        onClick={(e) =>
                                          handleRadioButton(
                                            profile_id,
                                            e,
                                            index
                                          )
                                        }
                                      />
                                      <label
                                        className="iiris-form-check-label"
                                        for={item.id}
                                      >
                                        {item.name}
                                      </label>
                                    </div>
                                  ))}
                              </div>

                              <div
                                className={
                                  classes[
                                    hasError(profile_id)
                                      ? "iiris-error-space"
                                      : "iiris-hidden"
                                  ]
                                }
                              >
                                {t("please_select")}{" "}
                                {getQuestionTitle(question).toLowerCase()}
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {countryType === "A" && (
              <div>
                <div className={classes["iiris-formbox"]}>
                  <div className="iiris-input-group">
                    <p>{t("news_promotions")}</p>
                  </div>
                  <div className="iiris-form-group">
                    <div class="iiris-form-check iiris-form-check-inline">
                      <input
                        name="inlineRadioOptions1"
                        class="iiris-form-check-input"
                        type="radio"
                        id="inlineRadio11"
                        value="YES"
                        onClick={handleTypeASiteConsent}
                      />
                      <label class="iiris-form-check-label" for="inlineRadio11">
                        {t("yes")}
                      </label>
                    </div>
                    <div class="iiris-form-check iiris-form-check-inline">
                      <input
                        name="inlineRadioOptions1"
                        class="iiris-form-check-input"
                        type="radio"
                        id="inlineRadio12"
                        value="NO"
                        onClick={handleTypeASiteConsent}
                      />
                      <label class="iiris-form-check-label" for="inlineRadio12">
                        {t("no")}
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    classes[
                      hasError("Aterms") ? "iiris-error-space" : "iiris-hidden"
                    ]
                  }
                >
                  {t("please_consent")}
                </div>
              </div>
            )}

            {(countryType === "B" || countryType === "C") && (
              <div>
                <div className={classes["iiris-formbox"]}>
                  <label className={classes["iiris-checkbox-container"]}>
                    <input
                      type="checkbox"
                      className={classes["iiris-checkbox-style"]}
                      onClick={handleTypeBSiteConsent}
                    />
                    <span className={classes["iiris-checkmark"]}></span>
                    <span>{t("tick_here")}</span>
                    <strong> {t("do_not")}</strong>
                    <span> {t("want_to_receive")}</span>
                  </label>
                </div>
              </div>
            )}

            {countryType === "D" && (
              <div>
                <div className={classes["iiris-formbox"]}>
                  <div className="iiris-input-group">
                    <p>{t("by_continuing")}</p>
                  </div>
                </div>
                <div className={classes["iiris-formbox"]}>
                  <label className={classes["iiris-checkbox-container"]}>
                    <input
                      type="checkbox"
                      onClick={handleTypeDConsent}
                      className={classes["iiris-checkbox-style"]}
                    />
                    <span className={classes["iiris-checkmark"]}></span>
                    <span>
                      {t("i_agree")} &nbsp;
                      <a
                        style={{
                          textDecoration: "underline",
                          color: "#0593FF",
                        }}
                        href="https://www.informa.com/privacy-policy/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <b>{t("privacy_policy")}</b>
                      </a>
                    </span>
                  </label>
                </div>
                <div
                  className={
                    classes[
                      hasError("Cterms") ? "iiris-error-space" : "iiris-hidden"
                    ]
                  }
                >
                  {t("please_privacy_policy")}
                </div>
              </div>
            )}
            {countryType !== "" && (
              <div
                style={{
                  width: "100%",
                  marginBottom: "0.8rem",
                }}
              >
                <div className={classes["iiris-formbox"]}>
                  <span>
                    {t("opt_out")}{" "}
                    <a
                      style={{
                        textDecoration: "underline",
                        color: "#0593FF",
                      }}
                      href="https://www.informa.com/privacy-policy/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b>{t("privacy_policy")}</b>
                    </a>
                  </span>
                </div>
              </div>
            )}

            {pages.length > 1 && pageNumber !== 1 && (
              <div className="iiris-text-center">
                <div className={classes["iiris-register-button-container"]}>
                  <button
                    onClick={(e) => handlePageClick(e, "prev")}
                    className={`${classes["iiris-social-btn"]} iiris-btn iiris-btn-block `}
                    style={{
                      color: identityConfig.skin.skin_color,
                      background: identityConfig.skin.skin_background,
                    }}
                  >
                    Prev Page
                  </button>
                </div>
              </div>
            )}

            {pages.length > 1 && pageNumber !== pages.length && (
              <div className="iiris-text-center">
                <div className={classes["iiris-register-button-container"]}>
                  <button
                    onClick={(e) => handlePageClick(e, "next")}
                    className={`${classes["iiris-social-btn"]} iiris-btn iiris-btn-block `}
                    style={{
                      color: identityConfig.skin.skin_color,
                      background: identityConfig.skin.skin_background,
                    }}
                  >
                    Next Page
                  </button>
                </div>
              </div>
            )}

            <div className="iiris-text-center iiris-btn-center">
              <div className={classes["iiris-register-button-container"]}>
                <button
                  onClick={finishSignUp}
                  type="button"
                  className={`${classes["iiris-social-btn"]} iiris-btn iiris-btn-block `}
                  style={{
                    color: identityConfig.skin.skin_color,
                    background: identityConfig.skin.skin_background,
                  }}
                >
                  {t("submit")}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {!isLoading && isLocalUser && (
        <RedirectToParent userObj={userObj} identityConfig={identityConfig} />
      )}
    </div>
  );
};
